import { useEffect, useRef } from 'react';
import { useTheme } from '../contexts/ThemeContext';


const SignalVisualizer = ({ analyserRef, isActive, width = 200, height = 40 }) => {
  const canvasRef = useRef(null);
  const { darkMode } = useTheme();

  useEffect(() => {
    let animationFrame;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    const activeColor = darkMode ? '#f59e0b' : '#d97706';

    const render = () => {
      ctx.clearRect(0, 0, width, height);
      
      let data;
      if (analyserRef?.current) {
        const dataArray = new Uint8Array(analyserRef.current.frequencyBinCount);
        analyserRef.current.getByteFrequencyData(dataArray);
        data = dataArray;
      } else if (isActive) {
        data = new Uint8Array(32).map(() => Math.random() * 150 + 50);
      }

      if (data) {
        const barWidth = width / data.length;
        data.forEach((value, i) => {
          const barHeight = (value / 255) * height;
          ctx.fillStyle = activeColor;
          ctx.globalAlpha = 0.7;
          ctx.fillRect(i * barWidth, height - barHeight, barWidth - 2, barHeight);
        });
      }
      animationFrame = requestAnimationFrame(render);
    };

    render();
    
    return () => cancelAnimationFrame(animationFrame);
  }, [isActive, analyserRef, width, height, darkMode]);

  return (
    <canvas 
      ref={canvasRef} 
      width={width} 
      height={height} 
      className="w-full h-full opacity-90" 
    />
  );
};

export default SignalVisualizer;

